export enum ResetPasswordErrorEnum {
    TAMANHO_MININO = 'O campo "Senha" deve conter no mínimo 5 caracteres.',
    VALOR_VAZIO = 'O campo "Senha" não pode ser vazio".',
    VALOR_VAZIO_CONFIRMAR_SENHA = 'O campo "Confirme a nova senha" não pode ser vazio.',
    TAMANHO_MININO_CONFIRMAR_SENHA = 'O campo "Confirme a nova senha" deve conter no mínimo 5 caracteres.',
    VALORES_DIFERENTES = "A nova senha e sua confirmação devem ser iguais.",
}
